import React from "react";

const About = () => {
  return (
    <div className="container-fluid">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#17a2b8" fill-opacity="1" d="M0,128L60,117.3C120,107,240,85,360,101.3C480,117,600,171,720,165.3C840,160,960,96,1080,64C1200,32,1320,32,1380,32L1440,32L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path></svg>
      <h1>ABOUT GITHUB USERS' FINDER</h1>
      <p>This is an app built with React, Hooks, Context-API and Bootstrap. It enables an easy search for a github user. The user github details like: The picture of the github user, the number of Public Repos, the number of Followers, the recent projects, and etc can be viewed</p>
      
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#17a2b8" fill-opacity="1" d="M0,128L60,117.3C120,107,240,85,360,101.3C480,117,600,171,720,165.3C840,160,960,96,1080,64C1200,32,1320,32,1380,32L1440,32L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>
    </div>
  );
};

export default About;
